/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { Button, Select, Form, Row, Modal, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';

import { MdVideoCall } from 'react-icons/md';
import FileSaver from 'file-saver';
import { exportVideoUploaded } from 'app/modules/accounts/redux/AccountCRUD';
import { LockOutlined, UserOutlined } from '@ant-design/icons';

const { Option } = Select;

export const AddKeyUpload = (props: any) => {
    const [form] = useForm();

    const [loading, setLoading] = useState(false);

    const { isModalOpen, setIsModalOpen, setLoadingExport } = props;

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinishChannelInHand = async (values: any) => {
        setLoading(true);
        setLoadingExport(true);

        try {
            const response: any = await exportVideoUploaded(form.getFieldValue('user_target'), {});

            if (response?.data?.success) {
                let filenameXLSX = response?.data?.data?.file_name;
                const pdfUrl = `${process.env.REACT_APP_API_URL}download-public?file=${filenameXLSX}`;
                FileSaver.saveAs(pdfUrl, filenameXLSX);

                Modal.success({
                    title: 'Tải xuống thành công',
                    content: `File: ${filenameXLSX}`,
                });
            }

            if (response?.error?.error) {
                Modal.warn({
                    title: 'Tải xuống thất bại',
                    content: response?.error?.error,
                });
            }

            setIsModalOpen(false);
            setLoading(false);
            setLoadingExport(false);
            form.resetFields();
        } catch (err) {
            setLoading(false);
            setLoadingExport(false);
            setIsModalOpen(false);
            form.resetFields();
            console.log(err);
        }
    }

    return (
        <Modal
            centered
            width='300px'
            title={'Nhập Key mới'}
            open={isModalOpen}
            onOk={onFinishChannelInHand}
            onCancel={handleCancel}
            footer={null}
        >
            <Form form={form} layout="vertical" preserve={false} onFinish={onFinishChannelInHand}>
                <Form.Item 
                    label="Key"
                    name="user_target"
                    className='pb-2'
                    rules={[{
                        required: true,
                        message: 'Chưa nhập key'
                    }]}
                >
                    <Input.Password
                        placeholder="xxxxxxxxxxxxxxxxxxxxxxx"
                        autoComplete='off'
                        prefix={<LockOutlined rev={undefined} />}
                    />
                </Form.Item>
                <Row justify='end'>
                    <Button onClick={handleCancel} className='mr-2'>
                        Hủy
                    </Button>
                    <Button type='primary' loading={loading} htmlType='submit' style={{ display: 'flex' }}>
                        <MdVideoCall fontSize={'20px'} className='mr-2' /> Kiểm tra
                    </Button>
                </Row>
            </Form>
        </Modal>
    )
}